import { render, staticRenderFns } from "./OrkPrice.vue?vue&type=template&id=07f4d435&functional=true&"
import script from "./OrkPrice.vue?vue&type=script&lang=js&"
export * from "./OrkPrice.vue?vue&type=script&lang=js&"
import style0 from "./OrkPrice.vue?vue&type=style&index=0&id=07f4d435&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports